<common-mojo-card>
  <mojo-functions-and-departments-filters
    [jobStatusFilterFn]="true"
    (jobStatusChange)="changeJobStatus($event)"
    (filterChange)="changeFunctionAndDepartmentsFilters($event)"
  >
  </mojo-functions-and-departments-filters>
</common-mojo-card>
